<template>
  <search-bar
    name="searchCompetence"
    libelle=""
    :value="searchCompetence"
    :placeholder="libelle"
    :big="false"
    @input="
      (newValue) => {
        searchCompetence = newValue;
      }
    "
    @displaySuggestionsList="
      (state) => {
        isSuggestionsCompetencesDisplayed = state;
      }
    "
    :is-searching="isSearchingCompetences"
    :has-suggestion="isSuggestionsCompetencesDisplayed"
  >
    <template #suggestionsList>
      <!-- BEGIN Items for template MULTI1 type (competences linguistiques) -->
      <!-- <div v-for="template in templatesMulti1" :key="template.id">
        <div
          class="flex space-x-1 items-center cursor-default p-3 text-base font-normal bg-white bg-opacity-0 odd:bg-gray-200 odd:bg-opacity-50 hover:bg-indigo-200 hover:bg-opacity-100 odd:hover:bg-indigo-200 odd:hover:bg-opacity-100"
          @click.stop="selectTemplate(template)"
        >
          {{ template.name }}
        </div>
        <div
          v-for="(competence, competenceIndex) in Object.keys({ ...template.data[0] })
              .filter((key) => domaine[key].display_cartographie)
              .reduce((result, key) => {
                result[key] = domaine[key];
                return result;
              }, {})"
          :key="template.name + template.id + competenceIndex"
          class="flex space-x-1 items-center cursor-default p-3 text-base font-normal bg-white bg-opacity-0 odd:bg-gray-200 odd:bg-opacity-50 hover:bg-indigo-200 hover:bg-opacity-100 odd:hover:bg-indigo-200 odd:hover:bg-opacity-100"
          @click.stop="selectCompetence(template, null, competenceIndex)"
        >
          <icon
            name="check"
            :class="{
              'text-teal-600': filter.some(
                (competence) =>
                  competence.template.id === template.id &&
                  competence.domaine === null &&
                  competence.competence === competenceIndex
              ),
              'text-transparent': !filter.some(
                (competence) =>
                  competence.template.id === template.id &&
                  competence.domaine === null &&
                  competence.competence === competenceIndex
              ),
            }"
          />
          <div>
            {{ competence.libelle }}
          </div>
        </div>
      </div> -->
      <!-- END Items for template MULTI1 type -->
      <!-- BEGIN Items for template MULTI2 type (competences socio-professionnelles) -->
      <div v-for="template in templatesMulti2" :key="template.id">
        <div
          class="flex space-x-1 items-center cursor-default p-3 text-base font-medium bg-white bg-opacity-0 odd:bg-gray-200 odd:bg-opacity-50 hover:bg-indigo-200 hover:bg-opacity-100 odd:hover:bg-indigo-200 odd:hover:bg-opacity-100"
          @click.stop="selectTemplate(template)"
        >
          {{ template.name }}
        </div>
        <div
          v-for="(competence, competenceIndex) in template.data[0]
            .filter($filterEvaluationIntitulesMulti2)[0]
            .criterions.filter(
              (criterion) =>
                template.name.includes(searchCompetence.toLocaleLowerCase()) ||
                (criterion.libelle &&
                  criterion.libelle
                    .toLocaleLowerCase()
                    .includes(searchCompetence.toLocaleLowerCase()))
            )"
          :key="template.name + template.id + competenceIndex"
          class="flex space-x-1 items-center cursor-default p-3 text-base font-normal bg-white bg-opacity-0 odd:bg-gray-200 odd:bg-opacity-50 hover:bg-indigo-200 hover:bg-opacity-100 odd:hover:bg-indigo-200 odd:hover:bg-opacity-100"
          @click.stop="selectCompetence(template, null, competenceIndex)"
        >
          <icon
            name="check"
            :class="{
              'text-teal-600': filter.some(
                (competence) =>
                  competence.template.id == template.id &&
                  competence.competence == competenceIndex
              ),
              'text-transparent': !filter.some(
                (competence) =>
                  competence.template.id == template.id &&
                  competence.competence == competenceIndex
              ),
            }"
          />
          <div>
            {{ competence.description }}
          </div>
        </div>
      </div>
      <!-- END Items for template MULTI2 type -->
      <!-- BEGIN Items for template MULTI3 type (competences clés et compétences informatiques) -->
      <div v-for="template in templatesMulti3" :key="template.id">
        <div
          class="flex space-x-1 items-center cursor-default p-3 text-base font-medium bg-white bg-opacity-0 odd:bg-gray-200 odd:bg-opacity-50 hover:bg-indigo-200 hover:bg-opacity-100 odd:hover:bg-indigo-200 odd:hover:bg-opacity-100"
          @click.stop="selectTemplate(template)"
        >
          {{ template.name }}
        </div>
        <div
          v-for="(domaine, domaineIndex) in template.data[0]"
          :key="template.name + template.id + domaineIndex"
        >
          <div
            v-for="(competence, competenceIndex) in Object.keys({ ...domaine })
              .filter(
                (key) =>
                  domaine[key].display_cartographie &&
                  (domaine[key].libelle
                    .toLocaleLowerCase()
                    .includes(searchCompetence.toLocaleLowerCase()) ||
                    template.name
                      .toLocaleLowerCase()
                      .includes(searchCompetence.toLocaleLowerCase()))
              )
              .reduce((result, key) => {
                result[key] = domaine[key];
                return result;
              }, {})"
            :key="template.name + template.id + domaineIndex + competenceIndex"
            class="flex space-x-1 items-center cursor-default p-3 text-base font-normal bg-white bg-opacity-0 odd:bg-gray-200 odd:bg-opacity-50 hover:bg-indigo-200 hover:bg-opacity-100 odd:hover:bg-indigo-200 odd:hover:bg-opacity-100"
            @click.stop="
              selectCompetence(template, domaineIndex, competenceIndex)
            "
          >
            <icon
              name="check"
              :class="{
                'text-teal-600': filter.some(
                  (competence) =>
                    competence.template.id == template.id &&
                    competence.domaine == domaineIndex &&
                    competence.competence == competenceIndex
                ),
                'text-transparent': !filter.some(
                  (competence) =>
                    competence.template.id == template.id &&
                    competence.domaine == domaineIndex &&
                    competence.competence == competenceIndex
                ),
              }"
            />
            <div>
              {{
                domaine[0].libelle === competence.libelle
                  ? domaine[0].libelle
                  : domaine[0].libelle + ' - ' + competence.libelle
              }}
            </div>
          </div>
        </div>
      </div>
      <!-- END Items for template MULTI3 type -->
      <div v-if="templates.length == 0" class="text-base font-normal p-5">
        Aucun résultat
      </div>
    </template>
  </search-bar>
</template>

<script>
import SearchBar from '../../../../components/Inputs/SearchBar.vue';
import Icon from '../../../../components/Icon.vue';

export default {
  components: {
    SearchBar,
    Icon,
  },

  props: {
    templates: Array,
    filter: Array,
    libelle: String,
  },

  data() {
    return {
      searchCompetence: '',
      isSuggestionsCompetencesDisplayed: false,
      isSearchingCompetences: false,
    };
  },

  methods: {
    selectTemplate(template) {
      this.$emit('selectTemplate', template);
    },
    selectCompetence(template, domaineIndex, competenceIndex) {
      this.$emit('selectCompetence', {
        template: template,
        domaine: domaineIndex === null ? null : parseInt(domaineIndex),
        competence: parseInt(competenceIndex),
      });
    },
  },

  computed: {
    //langues => there is not language competence in this module
    templatesMulti1() {
      return this.templates.filter((t) => t.type === 'multi1');
    },
    //Socio-pro
    templatesMulti2() {
      return this.templates.filter(
        (t) =>
          t.type === 'multi2' &&
          (t.name
            .toLocaleLowerCase()
            .includes(this.searchCompetence.toLocaleLowerCase()) ||
            t.data[0]
              .filter(this.$filterEvaluationIntitulesMulti2)[0]
              .criterions.some(
                (criterion) =>
                  criterion.libelle &&
                  criterion.libelle
                    .toLocaleLowerCase()
                    .includes(this.searchCompetence.toLocaleLowerCase())
              ))
      );
    },
    //Clés & informatiques
    templatesMulti3() {
      return this.templates.filter(
        (t) =>
          t.type === 'multi3' &&
          (t.name
            .toLocaleLowerCase()
            .includes(this.searchCompetence.toLocaleLowerCase()) ||
            t.data[0].some(
              (domaine) =>
                Array.isArray(domaine) &&
                domaine.filter(
                  (competence) =>
                    competence.display_cartographie &&
                    competence.libelle
                      .toLocaleLowerCase()
                      .includes(this.searchCompetence.toLocaleLowerCase())
                ).length > 0
            ))
      );
    },
  },
};
</script>
